export default "__VITE_ASSET__ylZYtjZh__"